var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"bbe-bounce"}},[(_vm.show)?_c('div',{staticClass:"bbe-popup-list"},_vm._l((_vm.options),function(ref){
var title = ref.title;
var action = ref.action;
return _c('div',{key:title,staticClass:"bbe-popup-list__option",on:{"click":action}},[_vm._v("\n      "+_vm._s(title)+"\n    ")])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6609833c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/PopupWithOptions/PopupWithOptions.vue
// module id = null
// module chunks = 